import { CUSTOM_ICON_NAME_SET, CUSTOM_SPRITE_PATH } from '../../../../icons/generated/custom-icon-names';
import { resolveSolarIconHref } from './resolve-solar-icon-href';

export const resolveIconHref = (icon: string): string => {
  if (!icon) return '';

  if (CUSTOM_ICON_NAME_SET.has(icon)) return `${CUSTOM_SPRITE_PATH}#${icon}`;

  return resolveSolarIconHref(icon);
};
